import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCapturePumpColumn } from "../../../hooks/Capture";
import PumpColumns from "../PumpColumn/PumpColumns";

interface PumpColumnTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const PumpColumnTab: React.FC<PumpColumnTabProps> = ({ captureId, handleError, canEdit }) => {
  const { pumpColumnsData, isPending, createPumpColumn, updatePumpColumn, deletePumpColumn } = useCapturePumpColumn(captureId);

  if (isPending && pumpColumnsData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <PumpColumns
      pumpColumnsData={pumpColumnsData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createPumpColumn(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updatePumpColumn({ columnId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deletePumpColumn(id).catch(handleError);
      }}
    />
  );
};

export default PumpColumnTab;
